import React from 'react'
import './Breadcrumbs.css'
import arrow_icon from '../Assets/breadcrum_arrow.png'

const Breadcrumbs = () => {
  const product = JSON.parse(localStorage.getItem("currentProd"));
  return (
    <div className="breadcrumbs">
        HOME <img src={arrow_icon} alt=''/> {product.category} <img src={arrow_icon} alt=''/> {product.name}
    </div>
  )
}

export default Breadcrumbs